<template>
    <span class="subtitle-1">
        <v-select hide-details
            label="Período Letivo Vigente"
            v-model="pletivo"
            :items="computedPerlets"
            @update:modelValue="onSelectPerlet"></v-select>
    </span>
</template>
<script>
export default {
    data:()=> ({
        pletivo: null
    }),
    mounted(){
        this.init()
    },
    methods: {
        init(){
            const codp = localStorage.getItem('codperlet_checklist')
            if (codp){
                // Inicializa com último valor utilizado
                this.onSelectPerlet(codp)
            }else{
                // Inicializar com o período letivo atual padrão, px ano se a partir de novembro, caso contrario ano atual
                if (new Date().getMonth() >= 10){
                    this.onSelectPerlet(String(new Date().getFullYear() + 1))
                }else{
                    this.onSelectPerlet(String(new Date().getFullYear()))
                }
            }
        },
        onSelectPerlet(value){
            localStorage.setItem('codperlet_checklist', value)
            this.pletivo = value
            this.$emit('on-select-perlet', value)
        }
    },
    computed: {
        computedPerlets(){
            let perlets = []
            if (new Date().getMonth() > 7){
                perlets.push(String(new Date().getFullYear() + 1))
            }
            perlets.push(...[
                String(new Date().getFullYear()),
                String(new Date().getFullYear() - 1),
                String(new Date().getFullYear() - 2)
            ]);
            // Incluir próximo ano quando o mes atual foi superior a Agosto
            return perlets
        }
    }
}
</script>